import { IScope } from 'angular'
import { trackError } from '@vend/utilities'
import { flushSync } from 'react-dom'
import { $compile, $rootScope } from '../../ng-compat/imports'
import { WR_PRINTER_ID } from '../../directives/application/wr-printer'
import { env } from '../../../../lib/env'
import { PrintTypesHandled, setPrintPayload } from './PrintContainer'
import { PrintPayload } from './printTypes'

export interface PrintController {
  _print(options: PrintPayload): Promise<void>
}

export interface PrinterScope extends IScope {
  printerCtrl: PrintController
}

export async function print(printPayload: PrintPayload): Promise<void> {
  if (PrintTypesHandled.includes(printPayload.type)) {
    return reactPrint(printPayload)
  }

  const printScope = $rootScope.$new() as PrinterScope
  const printDirective = $compile(`<${WR_PRINTER_ID}></${WR_PRINTER_ID}>`)(
    printScope
  )

  document.body.appendChild(printDirective[0])

  try {
    // Convert to regular promise
    const printPromise = new Promise<void>((resolve, reject) => {
      printScope.printerCtrl._print(printPayload).then(resolve, reject)
    })
    await printPromise
  } catch (error) {
    trackError('[Print] Error when printing', { error })
  } finally {
    printDirective.remove()
    printScope.$destroy()
  }
}

const reactPrint = (printPayload: PrintPayload): Promise<void> => {
  return new Promise<void>(resolve => {
    // We need to ensure this is rendered before calling print,
    // as print will block the main thread.
    setTimeout(() => {
      flushSync(() => {
        setPrintPayload(printPayload)
      })
      window.print()
      // By not removing the printed element in dev it makes it
      // possible to insprect with the browser dev tools to enable
      // easier debuggging.
      if (env.isProduction()) {
        setPrintPayload(null)
      }
      resolve()
    })
  })
}
